import { Activities, Processes, ProcessesProgress } from '../models';
import { PagingParams, PagedResults } from '@abaco/web-common/src/Paging';
import { HTTPClient, propsToDatePaged } from '@abaco/web-common/src/HTTP';

export default class DashboardApi {

    private http: HTTPClient;

    constructor(http: HTTPClient){
        this.http = http;
    }

    async getProcessesToComplete(campaign: number, subjectId: number | null, scoSettore: string, paging: PagingParams): Promise<PagedResults<Processes>> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/dashboard/campaigns/${campaign}/processes`, {
            params: {
                offset: paging.offset,
                count: paging.count,
                subject_id: subjectId,
                sco_settore: scoSettore
            }
        });
        return res.data;
    }

    async getProcessesProgress(campaign: number | null, subjectId: number): Promise<ProcessesProgress[]> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/dashboard/subjects/${subjectId}/processes_progress`, {
            params: {
                campaign: campaign
            }
        });
        return res.data;
    }

    async getPlannedActivities(campaign: number, subjectId: number | null, groupCode: string | null, paging: PagingParams): Promise<PagedResults<Activities>> {
        const filter = [];
        if(groupCode) {
            filter.push(`group_code eq ${groupCode}`);
        }

        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/dashboard/campaigns/${campaign}/planned_activities`, {
            params: {
                filter: filter.length ? filter : undefined,
                subject_id: subjectId,
                offset: paging.offset,
                count: paging.count
            }
        });
        propsToDatePaged(res.data, ["planned_date"]);
        return res.data;
        /*
        return {
            "offset": 0,
            "count": 3,
            "totalcount": 3,
            "records": [
                {
                    "subject_id": 412626,
                    "planned_date": new Date(1638869564000),
                    "full_name": "AZIENDA TEST",
                    "act_type_description": "Visita in campo",
                    "act_id": 81923,
                    "group_code": "POST-CONTRACT"
                },
                {
                    "subject_id": 412626,
                    "planned_date": new Date(1638869564000),
                    "full_name": "AZIENDA TEST",
                    "act_type_description": "Visita in campo",
                    "act_id": 81921,
                    "group_code": "POST-CONTRACT"
                },
                {
                    "subject_id": 412890,
                    "planned_date": new Date(1639566298000),
                    "full_name": "TEST",
                    "act_type_description": "Valutazione preliminare",
                    "act_id": 81944,
                    "group_code": "PRE-CONTRACT"
                }
            ]
        };
        */
    }

}
